import { resolveTenantPrimaryColor } from '@/lib/tenant-media-defaults'

import { useTenant } from '@/contexts/tenant-context'
import { TenantStatus } from '@/enums/tenant-status.enum'

/**
 * Hook to access tenant configuration
 * Returns tenant config, loading state, and error
 */
export function useTenantConfig() {
  const { tenantConfig, tenantId, isLoading, error, refreshConfig } = useTenant()

  return {
    tenantConfig,
    tenantId,
    isLoading,
    error,
    refreshConfig,
    // Convenience getters
    theme: tenantConfig?.theme || {},
    customization: tenantConfig?.customization || {},
    features: tenantConfig?.features || [],
    isActive: tenantConfig?.status === TenantStatus.ACTIVE,
    tenantName: tenantConfig?.name?.trim() || '',
    logo: tenantConfig?.theme?.logo,
    /** Set only when configured in media defaults / theme; otherwise globals.css defaults apply. */
    primaryColor: resolveTenantPrimaryColor(
      tenantConfig?.customization,
      tenantConfig?.theme?.primaryColor
    ),
    secondaryColor: tenantConfig?.theme?.secondaryColor || '#6c757d',
  }
}
